import { render, staticRenderFns } from "./SupportingDocumentUpload.vue?vue&type=template&id=12681220&scoped=true&"
import script from "./SupportingDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocumentUpload.vue?vue&type=style&index=0&id=12681220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12681220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
